import { useMemo } from 'react';
import { PortalMode } from '../stores/portal.store';
import { useClientWidthOptions } from './use-client-width-options';

const modeOptions = [576, 992, 1280];

export const usePortalModeOptions = (): PortalMode => {
    const modeIndex = useClientWidthOptions(modeOptions, document.body);

    /* eslint-disable no-restricted-globals */
    const isTouch = useMemo(
        () =>
            'ontouchstart' in window ||
            navigator.maxTouchPoints > 0 ||
            (navigator as any).msMaxTouchPoints > 0,
        []
    );
    /* eslint-enable no-restricted-globals */

    return useMemo(
        () => ({
            view:
                modeIndex === 0
                    ? 'mobile'
                    : modeIndex === 1
                      ? 'tablet'
                      : modeIndex === 2
                        ? 'desktop_narrow'
                        : 'desktop_wide',
            mobile: modeIndex === 0,
            tablet: modeIndex === 1,
            desktop: modeIndex > 1,
            desktopNarrow: modeIndex === 2,
            desktopWide: modeIndex === 3,
            sidebarMenu: modeIndex === 3,
            touch: isTouch,
        }),
        [modeIndex, isTouch]
    );
};
